import {
  ActionIcon,
  Anchor,
  Group,
  Stack,
  StepperStep,
  Text,
  ThemeIcon,
  Tooltip,
} from "@mantine/core";
import { getProps } from "./ItemProps";
import { parseDate } from "../../../../../../../functions/dates";
import { useLeadsSheetStore } from "../../../../../../../stores/LeadsStore";
import DeleteNote from "./DeleteNote";
import { IconEdit, IconFilePencil } from "@tabler/icons-react";
import { useLanguage } from "../../../../../../../stores/LanguageStore";
import { useMemo, useState } from "react";
import NoteItemContent from "./NoteItemContent";
import {
  useProfileStore,
  useSessionStore,
} from "../../../../../../../stores/UserStore";

const TabNotesItem = ({ item, isLast, small, isPreview, isMobile }) => {
  const lang = useLanguage((s) => s.language);
  const current = useLeadsSheetStore((s) => s.current);
  const usersList = useSessionStore((s) => s.usersOptions);

  const [isEdit, setIsEdit] = useState(false);

  const editedBy = useMemo(() => {
    if (item?.updated_by) {
      if (item.updated_by === useProfileStore.getState().profile?.id) {
        return useProfileStore.getState().profile;
      }
      return usersList.find((x) => x.id === item?.updated_by);
    }
    return null;
  }, [item?.updated_by, usersList]);

  const programmation = useMemo(() => {
    return current?.programmations?.find(
      (x) => x.programmation_id === item.workflow_programmation_id
    );
  }, [current?.programmations, item.workflow_programmation_id]);

  return (
    <Stack gap={4} mt={-6} w={"100%"}>
      <Group>
        <StepperStep
          component={Group}
          // align="start"
          miw={120}
          gap={0}
          pl={3}
          style={{ cursor: "text" }}
          icon={
            <ThemeIcon
              variant="white"
              radius={"lg"}
              color={getProps(item)?.iconColor}
              style={{ boxShadow: "#00000021 1px 1px 3px" }}
              mt={-4}
              size={isMobile ? 12 : undefined}
            >
              <IconFilePencil size={isMobile ? 0 : 18} />
            </ThemeIcon>
          }
          label={
            <Group
              gap={"xs"}
              bg={"#fcfbff"}
              px={"xs"}
              pt={4}
              style={{
                borderTopLeftRadius: 12,
                borderTopRightRadius: 12,
                border: "1px solid #00000018",
                borderBottom: 0,
              }}
              miw={120}
            >
              <Text>{getProps(item).label}</Text>

              {programmation?.workflow_name && (
                <Anchor
                  fw={500}
                  href={`/statistics/campaigns?highlight=${programmation?.programmation_id}`}
                  target="_blank"
                >
                  {programmation?.workflow_name}
                  {item?.workflow_step_id && (
                    <span style={{ fontSize: 12, marginLeft: 16 }}>
                      ( {lang.prm.resume.step} #{item.workflow_step_id} )
                    </span>
                  )}
                </Anchor>
              )}
            </Group>
          }
          description={
            <Group
              bg={"#fcfbff"}
              px={"xs"}
              pb={6}
              mt={-4}
              pt={4}
              miw={120}
              style={{
                borderBottomLeftRadius: 12,
                borderBottomRightRadius: 12,
                border: "1px solid #00000018",
                borderTop: 0,
              }}
            >
              <Stack gap={4}>
                <Text size="sm">
                  {lang.prm.details.notes.created_on}: {parseDate(item?.date)},{" "}
                  <b style={{ fontWeight: 500 }}>
                    {item?.created_by?.first_name} {item?.created_by?.last_name}{" "}
                    #{item?.created_by?.id}
                  </b>
                </Text>
                {item.date_updated && (
                  <Text size="sm">
                    {lang.prm.details.notes.edited_on}:{" "}
                    {parseDate(item?.date_updated)},{" "}
                    <b style={{ fontWeight: 500 }}>
                      {editedBy?.first_name || ""} {editedBy?.last_name || ""} #
                      {item?.updated_by}
                    </b>
                  </Text>
                )}
              </Stack>
            </Group>
          }
          mih={0}
        />

        {!item?.isCreate &&
          !isPreview &&
          (isMobile ? (
            <Stack gap={"xs"}>
              <Tooltip label={lang.global.edit}>
                <ActionIcon
                  variant="light"
                  className="on-hover-opacity"
                  onClick={() => setIsEdit(true)}
                >
                  <IconEdit size={18} />
                </ActionIcon>
              </Tooltip>
              <DeleteNote id={item.id} isMobile />
            </Stack>
          ) : (
            <>
              <Tooltip label={lang.global.edit}>
                <ActionIcon
                  variant="light"
                  className="on-hover-opacity"
                  onClick={() => setIsEdit(true)}
                >
                  <IconEdit size={18} />
                </ActionIcon>
              </Tooltip>
              <DeleteNote id={item.id} />
            </>
          ))}
      </Group>
      <Group
        mih={32}
        pl={26}
        style={{
          borderLeft: isLast ? "1px solid transparent" : "1px solid #00000021",
        }}
        ml={17}
        mt={-10}
      >
        <NoteItemContent
          item={item}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
          small={small}
        />
      </Group>
    </Stack>
  );
};

export default TabNotesItem;
